import { render, staticRenderFns } from "./buscaAudio.vue?vue&type=template&id=eff85f9c&scoped=true&"
import script from "./buscaAudio.vue?vue&type=script&lang=js&"
export * from "./buscaAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff85f9c",
  null
  
)

export default component.exports